import { checkSearchObject } from "app/common/LocalFunction";
import { SurgeryProcedureType } from "app/common/Model/SurgeryProcedureType";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  deletesurgeryProcedureType,
  getSurgeryProcedureTypeById,
  pagingSurgeryProcedureType,
  saveOrUpdateSurgeryProcedureType
} from "app/services/SurgeryProcedureTypeService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class SurgeryProcedureTypeStore {
  listAllSurgeryProcedureType = [];
  searchSurgeryProcedureType = new SearchObject();
  pageSurgeryProcedureType = null;
  selectedSurgeryProcedureType = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteSurgeryProcedureType = false;
  recentlyUpdated = false;
  listSurgeryProcedureTypeCode = {};
  openSyncStore = null;
  openDrugSyncInventory = null;


  constructor() {
    makeAutoObservable(this);
  }


  handleOpenSyncStore = () => {
    this.openSyncStore = true
  }

  handleCloseSyncStore = () => {
    this.openSyncStore = false
  }
  handleOpenDrugSyncInventory = () => {
    this.openDrugSyncInventory = true
  }

  handleCloseDrugSyncInventory = () => {
    this.openDrugSyncInventory = false
  }

  getAllSurgeryProcedureType = () => {
    if (!this.listAllSurgeryProcedureType?.length || this.recentlyUpdated) {
      return pagingSurgeryProcedureType({
        pageIndex: 1,
        pageSize: 1000000,
      })
        .then(({ data }) => {
          this.listAllSurgeryProcedureType = data.content.map(item => item?.code)
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    }
  };

  pagingSurgeryProcedureType = async () => {
    return await pagingSurgeryProcedureType(this.searchSurgeryProcedureType)
      .then(({ data }) => {
        this.pageSurgeryProcedureType = data;
        this.listSurgeryProcedureTypeCode = data.content.map(item => item?.code)
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchSurgeryProcedureType) => {
    this.searchSurgeryProcedureType = checkSearchObject(
      this.searchSurgeryProcedureType,
      searchSurgeryProcedureType
    );
    this.pagingSurgeryProcedureType();
  };

  handleOpenFormCreateOrEdit = async (storeId) => {
    if (Boolean(storeId)) {
      try {
        const { data } = await getSurgeryProcedureTypeById(storeId);
        if (data) {
          this.selectedSurgeryProcedureType = data;
          this.openFormCreateOrEdit = true;
        }
      } catch {
        toast.error("Lấy dữ liệu có lỗi!");
      }
    } else {
      this.selectedSurgeryProcedureType = new SurgeryProcedureType();
      this.openFormCreateOrEdit = true;
    }
  };

  saveSurgeryProcedureType = async (store, { setSubmitting }) => {
    try {
      const { data } = await saveOrUpdateSurgeryProcedureType(store);
      if (data) {
        this.selectedSurgeryProcedureType = null;
        this.pagingSurgeryProcedureType();
        this.handleClosePopup();
        this.recentlyUpdated = true;

        toast.success("Lưu loại PTTT thành công!");
      }
    } catch {
      toast.error("Lưu loại PTTT thất bại!");
    } finally {
      setSubmitting(false);
    }
  };

  handleConfirmDeleteSurgeryProcedureType = async () => {
    try {
      await deletesurgeryProcedureType(this.selectedSurgeryProcedureType?.id);
      if (
        this.searchSurgeryProcedureType?.pageIndex > 1 &&
        this.pageSurgeryProcedureType?.content?.length === 1
      ) {
        this.searchSurgeryProcedureType.pageIndex -= 1;
      }
      this.pagingSurgeryProcedureType();
      this.recentlyUpdated = true;
      this.handleClosePopup();

      toast.success("Xóa loại PTTT thành công!");
    } catch (error) {
      toast.error("Xóa loại PTTT thất bại!");
    }
  };

  handleDeleteSurgeryProcedureType = (storeId) => {
    this.selectedSurgeryProcedureType = { id: storeId ?? "" };
    this.openConfirmDeleteSurgeryProcedureType = true;
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteSurgeryProcedureType = false;
  };

  resetSurgeryProcedureType = () => {
    this.searchSurgeryProcedureType = new SearchObject();
    this.pageSurgeryProcedureType = null;
    this.selectedSurgeryProcedureType = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteSurgeryProcedureType = false;
  };
}
